<template>
  <input :class="style({ isError })" :value="modelValue" v-bind="$attrs" @input="updateValue" />
</template>

<script setup lang="ts">
import { tv } from 'tailwind-variants';

interface Props {
  modelValue?: string | number;
  isError?: boolean;
}

withDefaults(defineProps<Props>(), {
  modelValue: '',
  isError: false,
});

interface Emits {
  (event: 'update:modelValue', value: string | number): void;
}

const emits = defineEmits<Emits>();

const updateValue = (e: Event) => {
  emits('update:modelValue', (e.target as HTMLInputElement).value);
};

/**
 * Style
 */
const style = tv({
  base: 'box-border h-12 w-full appearance-none rounded-none border border-solid border-light-bd-muted bg-white px-4 py-0 text-sm text-black1 outline-none transition-all duration-100 ease-in-out placeholder:text-gray2',
  variants: {
    isError: {
      true: 'border-red1 bg-red2 text-red1',
    },
  },
});
</script>
